module.exports = __webpack_public_path__ + "static/media/logo.1c6e218e.svg";